import { api } from './client';

export const condicoesPagamentoApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/condicoes-pagamento${qs ? `?${qs}` : ''}`);
  },
  criar: (dados) => api.post('/condicoes-pagamento', dados),
  remover: (id) => api.del(`/condicoes-pagamento/${id}`)
};
